
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

define('component!SpaceComposerModalComponent',['require','prop-types','react','create-react-class','react-dom','underscore','translate','classnames','component!ModalComponent','component!ValidatedInputComponent','mixins/ValidationMixin','services/SpaceService'],function (require) {
  'use strict';

  var PropTypes = require('prop-types');

  var React = require('react');
  var ReactCreateClass = require('create-react-class');
  var ReactDOM = require('react-dom');
  var _ = require('underscore');
  var t = require('translate');
  var classNames = require('classnames');

  var ModalComponent = require('component!ModalComponent');

  var ValidatedInputComponent = require('component!ValidatedInputComponent');
  var ValidationMixin = require('mixins/ValidationMixin');

  var SpaceService = require('services/SpaceService');

  var SpaceComposerModalComponent = ReactCreateClass({
    displayName: 'SpaceComposerModalComponent',

    mixins: [ValidationMixin],

    propTypes: {
      orgId: PropTypes.number.isRequired
    },

    validations: {
      name: {
        required: true,
        label: t('Workspace name #space.composer')
      }
    },

    getInitialState: function getInitialState() {
      this.modal = React.createRef();
      this.inputWorkspaceName = React.createRef();
      return {
        privacy: 'closed',
        autoJoin: false,
        name: '',
        isLoading: false
      };
    },

    onautoJoinValueChange: function onautoJoinValueChange(e) {
      this.setState({ autoJoin: e.target.checked });
    },

    render: function render() {
      var buttonClassSet = classNames({
        'button-new': true,
        'primary': true,
        'loader': this.state.isLoading
      });

      return React.createElement(
        'div',
        { className: 'space-composer-modal-component' },
        React.createElement(
          ModalComponent,
          _extends({ ref: this.modal }, this.props, { onClose: this.handleModalClosed }),
          React.createElement(
            'div',
            { className: 'modal-wrapper' },
            React.createElement(
              'h1',
              { className: 'modal-header header-title' },
              t('Create a new workspace #space.composer')
            ),
            React.createElement(
              'div',
              { className: 'modal-content' },
              React.createElement(
                'form',
                null,
                React.createElement(
                  'p',
                  null,
                  React.createElement(
                    'label',
                    { htmlFor: 'workspace-name' },
                    t('Workspace name #space.composer')
                  ),
                  React.createElement(ValidatedInputComponent, {
                    autoFocus: true,
                    type: 'text',
                    id: 'workspace-name',
                    placeholder: t("Type a name #space.composer"),
                    ref: this.inputWorkspaceName,
                    onKeyDown: this.handleOnInputKeyDown,
                    errors: this.getValidationErrors("name"),
                    valueHook: this.validatedLinkState("name")
                  })
                ),
                React.createElement(
                  'p',
                  null,
                  React.createElement(
                    'label',
                    { htmlFor: 'access-settings' },
                    t('Access settings #space.composer')
                  ),
                  React.createElement(
                    'span',
                    { onClick: this.handlePrivacy.bind(this, 'closed') },
                    React.createElement('input', { id: 'access-settings', type: 'radio', name: 'privacy', checked: this.state.privacy === 'closed', readOnly: true }),
                    t('Private #space.composer'),
                    ' ',
                    React.createElement(
                      'span',
                      { className: 'option-info' },
                      t('– not visible for others, invite only #space.composer')
                    )
                  ),
                  React.createElement(
                    'span',
                    { onClick: this.handlePrivacy.bind(this, 'open') },
                    React.createElement('input', { id: 'access-settings', type: 'radio', name: 'privacy', checked: this.state.privacy === 'open', readOnly: true }),
                    t('Open #space.composer'),
                    ' ',
                    React.createElement(
                      'span',
                      { className: 'option-info' },
                      t('– visible and open for all employees to join #space.composer')
                    )
                  ),
                  React.createElement(
                    'span',
                    { className: 'auto-join', style: { display: this.state.privacy === 'open' ? 'block' : 'none' } },
                    React.createElement('input', {
                      type: 'checkbox',
                      checked: this.state.autoJoin,
                      onChange: this.onautoJoinValueChange
                    }),
                    React.createElement(
                      'span',
                      null,
                      t('Automatically join new employees #space.composer')
                    )
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'modal-footer' },
              React.createElement(
                'button',
                { type: 'button', onClick: this.handleCancel, className: 'button-new secondary' },
                t('Cancel #space.composer')
              ),
              React.createElement(
                'button',
                { type: 'button', onClick: this.handleValidate, disabled: this.state.isLoading, className: buttonClassSet },
                t('Create #space.composer')
              )
            )
          )
        )
      );
    },

    _focusInput: function _focusInput() {
      if (this.inputWorkspaceName.current) {
        ReactDOM.findDOMNode(this.inputWorkspaceName.current).focus();
      }
    },

    handleValidate: function handleValidate() {
      this.validateClick(this.handleSubmit, this._focusInput).call(this);
    },

    handleOnInputKeyDown: function handleOnInputKeyDown(syntheticEvent) {

      if (syntheticEvent.key === 'Enter') {
        syntheticEvent.preventDefault();

        this.handleValidate();
      }
    },

    handlePrivacy: function handlePrivacy(privacy) {
      this.setState({
        privacy: privacy
      });
    },

    handleSubmit: function handleSubmit() {
      var promise;

      this.setState({
        isLoading: true
      });

      var attributes = {
        org_id: this.props.orgId,
        name: this.state.name,
        privacy: this.state.privacy,
        auto_join: this.state.autoJoin && this.state.privacy === 'open'
      };

      if (this.props.shareId) {
        promise = SpaceService.createSpaceWithShare(attributes, this.props.shareId);
      } else {
        promise = SpaceService.createSpace(attributes);
      }

      promise.done(function (response) {
        window.location.href = '{0}#invite/{1}'.format(response.url, response.space_id);
      });
    },

    handleCancel: function handleCancel() {
      this.modal.current.close();
    },

    open: function open() {
      this.modal.current.open();

      this._focusInput();
    },

    handleModalClosed: function handleModalClosed() {
      this.setState(this.getInitialState());
    }
  });

  return SpaceComposerModalComponent;
});
